import { render, staticRenderFns } from "./movementStockTable.vue?vue&type=template&id=67f04c7e&scoped=true"
import script from "./movementStockTable.vue?vue&type=script&lang=js"
export * from "./movementStockTable.vue?vue&type=script&lang=js"
import style0 from "./movementStockTable.vue?vue&type=style&index=0&id=67f04c7e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67f04c7e",
  null
  
)

export default component.exports